// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1fWWV","tab":"Tabs_tab__3LY5z","tabActive":"Tabs_tabActive__1fLs1"};